import Modal from "./modal";
import Overlay from "./overlay";
import Tooltip from "./tooltip";
import Carousel from "./carousel";
import DropdownMenu from "./dropdown-menu";
import Skeleton from "./skeleton";
import Button from "./button";
import Ribbon from "./ribbon";
import Popover from "./popover";
import Drawer from "./drawer";
import Text from "./text";
import Heading from "./heading";
export default {
  Modal,
  Tooltip,
  Carousel,
  DropdownMenu,
  Skeleton,
  Button,
  Ribbon,
  Popover,
  Overlay,
  Drawer,
  Text,
  Heading
};
//# sourceMappingURL=index.js.map